import "core-js/modules/es6.string.link";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import OpeningSelection from '~/components/molecules/Editorial/OpeningSelection.vue';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import Cta from '~/components/atoms/Cta.vue';
import BlockColors from '~/components/atoms/Editorial/BlockColors.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'IntroTitleCta',
  components: {
    OpeningSelection: OpeningSelection,
    TitleSection: TitleSection,
    SimpleParagraph: SimpleParagraph,
    Cta: Cta,
    BlockColors: BlockColors
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    title: function title() {
      return {
        text: this.payload.primary.title[0] || {},
        textColor: this.payload.primary.title_color || ''
      };
    },
    background: function background() {
      return {
        color: this.payload.primary.background_color || '',
        image: formatPrismicImage(this.payload.primary.background_image.url) || EMPTY_PIXEL
      };
    },
    simpleParagraph: function simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    colors: function colors() {
      return [this.payload.primary.color_one, this.payload.primary.color_two, this.payload.primary.color_three, this.payload.primary.color_four, this.payload.primary.color_five].filter(Boolean);
    },
    button: function button() {
      return {
        textBtn: this.payload.primary.button_text || '',
        type: this.payload.primary.button_type || 'primary',
        url: this.payload.primary.button_url.url || ''
      };
    },
    buttonTracking: function buttonTracking() {
      return {
        tracking: {
          data: {
            event_category: this.payload.primary.button_event_category,
            event_action: this.payload.primary.button_event_action,
            event_label: this.payload.primary.button_event_label
          }
        }
      };
    },
    elements: function elements() {
      return this.payload.items.map(function (item) {
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_1440']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
        return {
          props: {
            src: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
            alt: item.alt,
            title: item.title[0] || {},
            titleColor: item.title_color,
            subtitle: item.subtitle[0] || {},
            subtitleColor: item.subtitle_color,
            url: item.link.url,
            textBtn: item.button_text || '',
            type: item.button_type || '',
            withIcon: item.with_icon === 'true'
          },
          tracking: {
            data: {
              event_category: item.event_category,
              event_action: item.event_action,
              event_label: item.event_label
            }
          }
        };
      });
    }
  }
};